import * as React from 'react';
import { Button, Dialog, Portal, RadioButton } from 'react-native-paper';
import i18n from 'i18n-js';

import Sequence, { label, sequences } from '../constants/sequence';

export interface Props {
  visible: boolean;
  value: Sequence;
  setValue: (sequence: Sequence) => void;
  onDismiss: () => void;
}

// @todo consider Snackbar instead of HelperText

const SortDialog = (props: Props) => {
  const { value, setValue, visible, onDismiss } = props;

  return (
    <Portal>
      <Dialog visible={visible} onDismiss={onDismiss}>
        <Dialog.Title>{i18n.t('Sorting options')}</Dialog.Title>
        <Dialog.Content>
          <RadioButton.Group
            onValueChange={(newValue) => setValue(newValue as Sequence)}
            value={value}
          >
            {sequences.map((sequence) => (
              <RadioButton.Item
                key={sequence}
                label={i18n.t(label(sequence))}
                value={sequence}
              />
            ))}
          </RadioButton.Group>
        </Dialog.Content>
        <Dialog.Actions>
          <Button onPress={onDismiss}>{i18n.t('Ok')}</Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
};

export default SortDialog;
